<template>
  <Form :layout="searchFormLayout" ref="formRef" :model="formState">
    <Row v-if="stylization === 'jms' && showSearch !== false">
      <Col :span="24">
        <div style="margin-bottom: 15px" class="search_button">
          <smart-button icon="icon-sousuo" type="primary" class="margin-right" @click="onSearch()">
            {{ lang('查询') }}
          </smart-button>
          <smart-button icon="icon-shuaxin" class="margin-right" @click="resetForm">
            {{ lang('清空') }}
          </smart-button>
          <slot name="menuLeft"></slot>
        </div>
      </Col>
    </Row>
    <div style="display: flex; flex-wrap: wrap;margin: 10px 0;">
      <div v-for="(i, k) in option" :key="`${i.prop}-${k}`" :style="`width: ${i.searchWidth || searchItemWidth};margin-right:15px;`">
        <FormItem :name="i.prop">
          <template #label>
            <div>
              <span class="search_require_icon" v-if="i.searchRequired">*</span>
              <span>{{ i.label }}:</span>
            </div>
          </template>
          <component
            :key="formKey"
            :is="getComponent(i.type)"
            style="width: 100%"
            v-model:value="formState[i.prop]"
            :placeholder="getPlaceholder(i.placeholder, i.type)"
            :disabled="i.disabled"
            :options="i.dicData"
            v-bind="i"
          />
        </FormItem>
      </div>
      <div :style="`width:300px;margin-right:15px;`" v-if="stylization === 'cwh' && showSearch !== false" v-show="false">
        <div style="padding-top: 30px">
          <smart-button icon="icon-sousuo" type="primary" class="margin-right" @click="onSearch()">
            {{ lang('查询') }}
          </smart-button>
          <smart-button icon="icon-shuaxin" class="margin-right" @click="resetForm">
            {{ lang('清空') }}
          </smart-button>
        </div>
      </div>
    </div>
    <Row :gutter="24" v-if="stylization === 'cwh'">
      <Col :span="24">
        <div style="margin-top: 15px">
          <smart-button icon="ant-sousuo" type="primary" class="margin-right" @click="onSearch()">
            {{ lang('查询') }}
          </smart-button>
          <smart-button icon="ant-shuaxin" class="margin-right" @click="resetForm">
            {{ lang('清空') }}
          </smart-button>
          <slot name="menuLeft"></slot>
        </div>
      </Col>
    </Row>
  </Form>
</template>
<script lang="tsx" setup name="SmartSearch">
import SmartButton from '../smart-button/index.vue'
import { Form, FormItem, Row, Col } from 'ant-design-vue'
import { onMounted, ref, computed, watch } from 'vue'
import { getComponent } from '../utils/tools'
import { inject } from 'vue'

const formKey = ref(Date.now())

const formState = defineModel('form', {
  type: Object,
  default: () => ({})
})

const lang = inject('lang')
const stylization = inject('stylization')
const searchFormLayout = inject('searchFormLayout')
const searchItemWidth = inject('searchItemWidth')

const emit = defineEmits(['search', 'reset', 'ready'])
const props = defineProps(['option', 'showSearch', 'formData'])

const formRef = ref()
const option = computed(() => {
  setTimeout(() => {
    formKey.value = Date.now()
  })
  return props.option || []
})

const defaultValues = props.option.filter((i: Record<any, any>) => i.searchDefault !== undefined)

if (defaultValues.length > 0) {
  defaultValues.forEach((i: Record<any, any>) => {
    formState.value[i.prop] = i.searchDefault
  })
}

const onSearch = (page = { current: 1, pageSize: 20 }) => {
  const params = formRef.value.getFieldsValue()
  emit('search', Object.assign({}, page, params))
}

// 清空表单
const resetForm = () => {
  formRef.value.resetFields()
  emit('reset', Object.assign({}, formState))
}

const getPlaceholder = (str: any, type: string) => {
  if (str) return str
  switch (type) {
    case 'range-picker':
      return [lang('开始时间'), lang('结束时间')]
    default:
      return lang('请输入')
  }
}
onMounted(() => {
  emit('ready', formState)
})
defineExpose({
  resetForm,
  formState,
  onSearch,
  getFieldsValue: () => formRef.value.getFieldsValue(),
  resetFields: (nameList) => formRef.value.resetFields(nameList),
  setFieldValue: (fidle, value) => {
    formState.value[fidle] = value
  }
})
</script>
<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 5px;
}
.margin-right{
  margin-right: 10px;
}
</style>
